import { useQuery } from '@tanstack/react-query';
import listGeofences from '../../repository/geofences/listGeofences';

export const GEOFENCE_QUERY_KEY = 'geofences';

export const useFetchGeofences = ({ userIds, filterParams, ...options } = {}) => {
    return useQuery([GEOFENCE_QUERY_KEY, { userIds, filterParams }], () => listGeofences({ ids: userIds, filterParams }), {
        ...options,
    });
};
